(function(SCS) {
	'use strict';
	var search = SCS.search = SCS.search || {};
	search.trackers = search.trackers || {};
	// Define track logic as functions that can be called from the listeners

	var PARAM_MAPPING = {
		// mapping from internal => gsa param names
		href: 'url',
		query: 'q',
		start: 's',
		ctype: 'ct',
		cdata: 'cd',
		score: 'r'
	};

	function getTrackURL(props) {
		// jshint forin: false
		var name;
		var parameters = {
			ctype: 'OTHER',
			query: '',
			site: '',
			cdata: '{}',
			href: '',
			cq_ck: +new Date(),
			start: 0,
			score: 0
		};
		// Calculate cdata
		var cdata = {ssid: props.ssid, score: props.score};
		cdata.filters = [];
		for(name in (props.filter||{})) {
			cdata.filters.push(name+':'+props.filter[name]);
		}
		props.cdata = window.JSON.stringify(cdata);
		// Use params from props (if in whitelist)
		for(name in parameters) {
			if(name in props && props[name]) {
				parameters[name] = props[name];
			}
		}
		// Map parameters to GSA names
		for(name in PARAM_MAPPING) {
			if(name in parameters) {
				parameters[PARAM_MAPPING[name]] = parameters[name];
			}
			delete parameters[name];
		}
		// Convert params to query string
		parameters = search.util.param(parameters);
		return props.baseURL + '/click?' + parameters;
	}

	if(window.QUnit) {
		// Visible for testing
		search.internals = search.internals || {};
		search.internals.gsa = {
			getTrackURL: getTrackURL
		};
	}

	var listeners = {
		// Listeners here
		generalClick: function(props) {
			if(props.backendType && props.backendType !== 'gsa') {
				return;
			}
			if(!props.baseURL) {
				// No URL, no tracking
				return;
			}

			var img = document.createElement('img');
			img.src = getTrackURL(props);
		}
	};
	search.trackers.gsa = listeners;
})(window.SCS = window.SCS || {});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/trackers/gsa.js
// module id = 51
// module chunks = 0